// Display helpers for person/principal names.
export const firstName = (name) => {
  if (!name) return "";
  // First whitespace-separated token — keeps "Ella" from "Ella Lilley-Gasteiger".
  return String(name).trim().split(/\s+/)[0];
};

export const initials = (name) => {
  if (!name) return "";
  const parts = String(name).trim().split(/\s+/);
  return parts.slice(0, 2).map((p) => p[0]?.toUpperCase() || "").join("");
};
